import script from "./ModalProvider.vue?vue&type=script&lang=tsx"
export * from "./ModalProvider.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__